import { Routes, Route } from "react-router-dom";
import AgreementTypes from "./AgreementTypes";

const index = () => {
	return (
		<Routes>
			<Route index element={<AgreementTypes />} />
		</Routes>
	);
};

export default index;
